import React from 'react';

export interface ConfidenceView {
    label: 'High' | 'Medium' | 'Low';
    fg: string;
    bg: string;
    bar: string;
}

export function confidenceView(score: number): ConfidenceView {
    if (score >= 90) return { label: 'High', fg: '#0F7A5F', bg: '#E3F5EE', bar: '#1F9D6B' };
    if (score >= 70) return { label: 'Medium', fg: '#9A6B10', bg: '#FBF1DD', bar: '#D69E2E' };
    return { label: 'Low', fg: '#B23A4E', bg: '#FBE7EA', bar: '#D6607A' };
}

export const ConfidenceBar: React.FC<{ score: number }> = ({ score }) => {
    const v = confidenceView(score);
    return (
        <div>
            <div className="flex items-center gap-2 mb-[5px]">
                <span className="font-mono text-[13px] font-bold" style={{ color: v.fg }}>{score}%</span>
                <span className="text-[11px] font-bold px-[7px] py-[1px] rounded-[5px]" style={{ background: v.bg, color: v.fg }}>
                    {v.label}
                </span>
            </div>
            <div className="h-[5px] bg-mapper-gray-bg rounded-full overflow-hidden">
                <div className="h-full rounded-full" style={{ width: `${score}%`, background: v.bar }} />
            </div>
        </div>
    );
};
